import { render, staticRenderFns } from "./MapIconRestorauntSpett.vue?vue&type=template&id=bb3dbcfc&scoped=true&"
import script from "./MapIconRestorauntSpett.vue?vue&type=script&lang=js&"
export * from "./MapIconRestorauntSpett.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3dbcfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb3dbcfc')) {
      api.createRecord('bb3dbcfc', component.options)
    } else {
      api.reload('bb3dbcfc', component.options)
    }
    module.hot.accept("./MapIconRestorauntSpett.vue?vue&type=template&id=bb3dbcfc&scoped=true&", function () {
      api.rerender('bb3dbcfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconRestorauntSpett.vue"
export default component.exports